<template>
  <inline-overlay v-if="inline" />
  <iframe-overlay ref="iframe" :src="iframeSrc" v-else-if="iframeSrc" />
</template>

<script>
import IframeOverlay from "./IframeOverlay.vue";
import InlineOverlay from "./InlineOverlay.vue";

import routeIfNotCurrent from "js/src/mixins/routeIfNotCurrent.js";

export default {
  name: "TitoOverlay",

  mixins: [routeIfNotCurrent],

  props: {
    inline: {
      default() {
        return !!window.tito.config.inline;
      },
    },
  },

  data() {
    return {
      iframeSrc: null,
    };
  },

  components: { IframeOverlay, InlineOverlay },

  created() {
    this.requestConfigurationFromHostFrameIfOverlayInIframe();
    window.addEventListener("message", this.receiveMessage);

    this.setIframeSrc();
    setTimeout(this.setFocusOnOverlay, 500);
  },

  computed: {
    overlayInIframe() {
      return document.location.href.includes("v2/iframes/overlay");
    },
  },

  methods: {
    receiveMessage(message) {
      let action = message.data.action;
      if (action === "configuration.request" && !this.overlayInIframe) {
        this.sendConfigurationFromHostFrameToIframe();
      } else if (action === "configuration.send" && this.overlayInIframe) {
        this.setConfigurationSentFromHostFrameOnIframe(message.data);
      } else if (action === "route" && this.$route.path != message.data.route) {
        this.routeIfNotCurrent(message.data.route);
      } else if (action === "redirect") {
        document.location.href = message.data.url;
      }
    },

    requestConfigurationFromHostFrameIfOverlayInIframe() {
      if (this.overlayInIframe) {
        window.parent.postMessage({ action: "configuration.request" }, "*");
      }
    },

    sendConfigurationFromHostFrameToIframe() {
      if (!this.$el.contentWindow) {
        return;
      }
      this.$el.contentWindow.postMessage(
        {
          configuration: this.$store.state.configuration,
          activeWidgetId: this.$store.state.activeWidgetId,
          action: "configuration.send",
        },
        "*"
      );
    },

    setIframeSrc() {
      const fullPath = `${this.$route.fullPath}`;
      const parts = [
        `https://${window.tito.config.js_host}/v2/iframes/overlay?uid=`,
        this._uid,
      ];
      if (window.tito.config.key) {
        parts.push("&key=");
        parts.push(encodeURIComponent(tito.config.key));
      }
      if (window.tito.config.testMode) {
        parts.push("&plugins=test_mode")
      }
      parts.push("&tito=");
      parts.push(encodeURIComponent(fullPath));
      this.iframeSrc = parts.join("");
    },

    setConfigurationSentFromHostFrameOnIframe(data) {
      this.$store.commit("setConfiguration", data.configuration);
      this.$store.commit("setActiveWidgetId", data.activeWidgetId);
    },

    setFocusOnOverlay() {
      if (this.$el.contentWindow) {
        this.setFocusOnIframeOverlay();
      } else {
        this.setFocusOnInlineOverlay();
      }
    },

    setFocusOnIframeOverlay() {
      this.$el.contentWindow.focus();
    },

    setFocusOnInlineOverlay() {
      const firstInput = this.$el.querySelector("input");
      if (firstInput) {
        firstInput.focus();
      } else {
        // if registration unavailable
        const closeLink = this.$el.querySelector("a");
        if (closeLink) {
          closeLink.focus();
        }
      }
    },
  },
};
</script>
